import React, { FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { filter } from 'lodash';
import TabNavigations from '@src/components/TabNavigations';
import {
  SETTINGS_ROUTE,
  SETTINGS_BILLING_ROUTE,
  SETTINGS_COMPANY_INFORMATION_ROUTE,
  SETTINGS_TEAM_ROUTE,
  SETTINGS_SECURITY,
} from '@src/Routes/links';
import { useSessionQuery } from '@src/graphql/generated';
import SettingsBilling from './SettingsBilling';
import CompanyInformation from './CompanyInformation';
import SettingsTeam from './SettingsTeam';
import { Security } from './Security';
import './styles.scss';

export const Settings: FC = () => {
  const { data: sessionData } = useSessionQuery();

  const rights = sessionData?.currentRecruiter?.rights;

  if (!rights) {
    return null;
  }

  const hasBilling = !!rights?.billing;

  const TABS = [
    {
      isShown: hasBilling,
      label: 'Billing',
      name: 'billing',
      to: SETTINGS_BILLING_ROUTE,
    },
    {
      isShown: hasBilling,
      label: 'Company information',
      name: 'company-information',
      to: SETTINGS_COMPANY_INFORMATION_ROUTE,
    },
    {
      isShown: true,
      label: 'Team',
      name: 'Team',
      to: SETTINGS_TEAM_ROUTE,
    },
    {
      isShown: rights.toggle2FA,
      label: 'Security',
      name: 'Security',
      to: SETTINGS_SECURITY,
    },
  ];

  const redirectToMainRoute = <Redirect to={hasBilling ? SETTINGS_BILLING_ROUTE : SETTINGS_TEAM_ROUTE} />;

  const redirectToTeamRoute = <Redirect to={SETTINGS_TEAM_ROUTE} />;

  return (
    <div className="settings">
      <div className="settings__header">
        <div className="settings__header-title">Settings</div>

        <TabNavigations className="settings__tabs" tabs={filter(TABS, 'isShown')} />
      </div>

      <div className="settings__body">
        <Switch>
          <Route exact path={SETTINGS_ROUTE}>
            {redirectToMainRoute}
          </Route>

          <Route exact path={SETTINGS_TEAM_ROUTE}>
            <SettingsTeam inviteTeam={!!rights.inviteTeam} />
          </Route>

          <Route exact path={SETTINGS_BILLING_ROUTE}>
            {hasBilling ? <SettingsBilling /> : redirectToTeamRoute}
          </Route>

          <Route exact path={SETTINGS_COMPANY_INFORMATION_ROUTE}>
            {hasBilling ? <CompanyInformation /> : redirectToTeamRoute}
          </Route>

          {rights.toggle2FA ? <Route component={Security} exact path={SETTINGS_SECURITY} /> : null}

          {redirectToMainRoute}
        </Switch>
      </div>
    </div>
  );
};
